var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2",attrs:{"id":"logo-group"}},[_c('router-link',{attrs:{"to":_vm.to.id ? {name: 'organization.dashboard', id: _vm.to.id} : {name: 'home'}}},[_c('logo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }